import { useState, useEffect } from "react";
import axios from 'axios';
import { devURL } from "../constants/constants";
import '../styles/settings.css';

export default function Settings() {
    const user = localStorage.getItem("user");
    const [ phone, setPhone ] = useState("");
    const [ notificationsCount, setNotificationsCount ] = useState(0);
    const [ enabled, setEnabled ] = useState(false);
    const [ saving, setSaving ] = useState(false);
    const [ message, setMessage ] = useState(null);

    useEffect(() => {
        if (!user) return;
        async function loadSettings() {
            try {
                const response = await axios({
                    method: 'get',
                    url: `${devURL}/settings?user=${user}`
                });
                setPhone(response.data.phone ?? "");
                setNotificationsCount(response.data.notificationsCount ?? 0);
                setEnabled(response.data.enabled ?? false);
            } catch (error) {
                console.log(error);
            }
        }
        loadSettings();
    }, [user]);

    const onSubmit = async e => {
        e.preventDefault();
        setSaving(true);
        setMessage(null);
        try {
            await axios({
                method: 'post',
                url: `${devURL}/settings`,
                data: {
                    user,
                    phone,
                    notificationsCount: Number(notificationsCount),
                    enabled
                }
            });
            setMessage("Zapisano ustawienia.");
        } catch (error) {
            console.log(error);
            setMessage("Nie udało się zapisać ustawień.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="settings">
            <h1>Ustawienia</h1>
            <h2 className="settings-subtitle">Ustawienia funkcji powiadomień SMS - zbiorniki paliw</h2>
            {user && <p className="settings-user">Konto: <span>{user}</span></p>}
            <form className="settings-form" onSubmit={onSubmit}>
                <label>
                    Numer telefonu
                    <input
                        type="tel"
                        placeholder="np. 500600700"
                        value={phone}
                        onChange={e => setPhone(e.target.value)}
                    />
                </label>
                <label>
                    Ilość powiadomień
                    <input
                        type="number"
                        min="0"
                        value={notificationsCount}
                        onChange={e => setNotificationsCount(e.target.value)}
                    />
                </label>
                <label className="settings-toggle">
                    Powiadomienia SMS
                    <button
                        type="button"
                        className={`toggle-switch ${enabled ? 'toggle-switch--on' : ''}`}
                        onClick={() => setEnabled(!enabled)}
                        aria-pressed={enabled}
                    >
                        <span className="toggle-switch__knob"/>
                    </button>
                </label>
                <button type="submit" className="btn-save" disabled={saving}>
                    {saving ? 'Zapisywanie...' : 'Zapisz'}
                </button>
                {message && <p className="settings-message">{message}</p>}
            </form>
        </div>
    )
}
